/**
 * Leitor de SSE sobre `fetch` (EventSource não faz POST nem manda corpo).
 * Separado do hook para ser testável em Node: recebe um ReadableStream e
 * entrega cada `data:` já parseado.
 */

import type { AssistenteEvento } from "@shared/assistente-contracts";

export async function lerEventosSse(
  body: ReadableStream<Uint8Array>,
  onEvento: (evento: AssistenteEvento) => void,
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  const processar = (bloco: string) => {
    const dados = bloco
      .split("\n")
      .filter((l) => l.startsWith("data:"))
      .map((l) => l.slice(5).trim())
      .join("\n");
    if (!dados) return;
    try {
      onEvento(JSON.parse(dados) as AssistenteEvento);
    } catch {
      /* linha malformada: ignora, o próximo evento segue */
    }
  };
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let sep: number;
      while ((sep = buffer.indexOf("\n\n")) >= 0) {
        processar(buffer.slice(0, sep));
        buffer = buffer.slice(sep + 2);
      }
    }
    if (buffer.trim()) processar(buffer);
  } finally {
    reader.releaseLock();
  }
}
